export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/brand-maestro.5655f06b.svg","height":16,"width":26,"blurWidth":0,"blurHeight":0};